import React from 'react';
import useTheme from "@mui/material/styles/useTheme";
import useMediaQuery from '@mui/material/useMediaQuery'
import { useStyles } from "../styles/styles";
import AppBar from '@mui/material/AppBar';
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

const Header = () => {
    const classes = useStyles;
    const theme = useTheme();
    const smallHeader = useMediaQuery(theme.breakpoints.down('lg'));

    return (
        <div style={classes.root} >
            <AppBar position="static" color="transparent" sx={{backgroundColor: '#f5f5ff', marginBottom: 1}} >
                <Toolbar style={smallHeader ? {padding: ''} : {padding: '.6rem'}}>
                    <>
                        <Typography component='div' sx={classes.menuTitle}>
                            <img src='/Logo-Neumo-Payments-logo.png' alt='Neumo Payments' style={smallHeader ? {height: '30px'} : {height: '35px'}}/>
                        </Typography>
                    </>
                </Toolbar>
            </AppBar>
        </div>
    );
}

export default Header;
